var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-default",attrs:{"id":"clearFilterButton","type":"button"},on:{"click":function($event){return _vm.reloadPage()}}},[_vm._v("\n    "+_vm._s(_vm.$lang('Wyczyść filtry'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }